<div class="icon-text-date-cell">
    <div class="icon-text-date-cell-container">
      <div class="flex-div">
        <p class="icon-text-date-cell-text-grey-bold-16px">
          {{ showInfo?.title }}
        </p>
        <span
          class="icon-text-date-cell-text-grey-bold-16px"
          [style.color]="
            active === 'Ativo' ? '#20A344' : '#808080'
          "
        >
          {{ active }}
        </span>
  
        <p class="icon-text-date-cell-text-grey-bold-14px">
          {{ showInfo?.description }}
        </p>

        <div class="item-right-container" *ngIf="showInfo">
          <button mat-raised-button class="btn-action primary-color" *ngIf="compareDate()" (click)="callOpenEditDialog(showInfo)">
              <img src="../../../../../assets/icons/lapis-edit.svg" />
          </button>
      
          <button mat-raised-button class="btn-action primary-color" 
            (click)="callOpenDeleteDialog(showInfo)">
              <img src="../../../../../assets/icons/lixeira2.svg" />
          </button>

          <button mat-raised-button class="btn-action primary-color" (click)="openReportDialog(showInfo)">
            <mat-icon class="btn-action">insert_chart_outlined</mat-icon>
          </button>
      
        </div>
      </div>
    </div>
  </div>
